import React from "react";
import Sidebar from "../../components/Sidebar";
import BottomNav from "../../components/BottomNav";

function ComingSoon({ title, subtitle }) {
  return (
    <section className="rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-900 shadow-sm p-6">
      <div className="inline-flex items-center gap-2 rounded-full border border-black/10 dark:border-white/10 bg-slate-50 dark:bg-white/5 px-3 py-1 text-xs text-slate-600 dark:text-slate-300">
        <span aria-hidden>⏳</span> Coming soon
      </div>

      <h1 className="mt-4 text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
        {title}
      </h1>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
        {subtitle}
      </p>

      <div className="mt-5 rounded-2xl border border-dashed border-black/10 dark:border-white/10 p-5 text-sm text-slate-500 dark:text-slate-400">
        Cette section sera disponible dans une prochaine mise à jour.
      </div>
    </section>
  );
}

export default function CommissionPage() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="flex">
        <Sidebar />
        <main className="flex-1 pb-28 md:pb-8">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-6">
            <ComingSoon
              title="Commissions"
              subtitle="Consultez vos commissions, leur origine et l’historique des paiements."
            />
          </div>

          <div className="md:hidden fixed bottom-0 left-0 w-full z-50">
            <BottomNav />
          </div>
        </main>
      </div>
    </div>
  );
}
